import { Cid11SelectFieldModel } from 'components/form/field/select/Cid11SelectField/model-cid11'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { SituacaoProblema } from 'graphql/types.generated'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'

import { Problema } from '../../../aside/types/ProblemaModel'
import { DataIdadeFieldModel } from '../../../components/DataIdadeField'

export interface ProblemaCondicaoModel extends SoapEditableItem {
  _id: ID
  problemaId?: ID
  ciap?: {
    id: ID
    codigo: string
    descricao: string
  }
  cid?: CidSelectFieldModel
  cid11?: Cid11SelectFieldModel
  incluirNaListaProblemas?: boolean
  observacao?: string
  situacaoProblema?: SituacaoProblema
  dataInicio?: DataIdadeFieldModel
  dataFim?: DataIdadeFieldModel
  problemaCondicaoEvoluir?: Problema
  isAvaliadoAgora?: boolean
  isRegistradoAgora?: boolean
  isAntecedentes?: boolean
  isAutomatico?: boolean
}

export interface ProblemaCondicaoAntecedenteModel extends ProblemaCondicaoModel {
  hasErrorInicio?: boolean
  hasErrorFim?: boolean
}

export interface TodosProblemasCondicoesModel {
  problemasCondicoesAvaliados?: ReadonlyArray<ProblemaCondicaoModel>
  problemasCondicoesAnteriores?: ReadonlyArray<ProblemaCondicaoModel>
}

export enum CiapCidRowState {
  DEFAULT,
  OBSERVACAO,
  EDICAO,
}

export interface TooltipAndIsDisabledModel {
  tooltip: string
  isDisabled: boolean
}
